<mat-card class="breadcrumb">
    <div class="row">
        <div class="col-md-7">
            <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
            <!--<mat-icon>arrow_forward_ios</mat-icon>-->
            <a [routerLink]="['/payments']">Payments</a>
        </div>
        <div class="col-md-5 text-right">

        </div>
    </div>
</mat-card>


<div class="row">
    <div class="col-md-4">
        <mat-form-field class="text-left" style="width: 100%">
            <input matInput [(ngModel)]="params.searchTerm" (keyup)="search()" placeholder="Name, email, reference, payUrl ID....">
        </mat-form-field>
    </div>
    <div class="col-md-2">
        <mat-form-field style="display: block">
            <mat-select
                [(ngModel)]="params.hotelID"
                (selectionChange)="search()"
                placeholder="Hotel">
                <mat-option value="">All Hotels</mat-option>
                <mat-option
                    [value]="sy.id"
                    *ngFor="let sy of (hotels$ | async)">
                    {{sy.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-1">
        <mat-form-field style="display: block">
            <mat-select
                [(ngModel)]="params.success"
                (selectionChange)="search()"
                placeholder="Succeeded">
                <mat-option [value]="-1">All</mat-option>
                <mat-option [value]="1">Success</mat-option>
                <mat-option [value]="0">Failed</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-1">
        <mat-form-field style="display: block">
            <mat-select
                [(ngModel)]="params.status"
                (selectionChange)="search()"
                placeholder="Status">
                <mat-option [value]="''">All</mat-option>
                <mat-option [value]="'Completed'">Completed</mat-option>
                <mat-option [value]="'Expired'">Expired</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-2">
        <mat-form-field style="display: block">
            <input type="search" matInput (dateChange)="search()" [(ngModel)]="startDate" (click)="startpicker.open()" [matDatepicker]="startpicker" placeholder="Date from">
            <mat-datepicker #startpicker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="col-md-2">
        <mat-form-field style="display: block">
            <input type="search" matInput (dateChange)="search()" [(ngModel)]="endDate" (click)="endpicker.open()" [matDatepicker]="endpicker" placeholder="Date to">
            <mat-datepicker #endpicker></mat-datepicker>
        </mat-form-field>
    </div>
    </div>
    <div class="row">
    <div class="col-md-2">
        <mat-form-field style="display: block">
            <mat-select
                [(ngModel)]="params.sort"
                (selectionChange)="search()"
                placeholder="Sort By">
                <mat-option
                    [value]="sort.ID"
                    *ngFor="let sort of params.sorts">
                    {{sort.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
	<div class="col-md-2">
        <mat-form-field style="display: block">
            <mat-select [(ngModel)]="params.limit" (ngModelChange)="search()" placeholder="Items per page">
                <mat-option
                    [value]="l"
                    *ngFor="let l of params.limits"
                >
                    {{ l }}
                </mat-option>
            </mat-select>
        </mat-form-field>
	</div>

    <div class="col-md-8 text-right">
        <a mat-raised-button color="warn" (click)="resetParams()">Clear</a>
    </div>

</div>


<mat-card class="no-records" *ngIf="!payments.length">
    No payments Listed
</mat-card>

<ng-container *ngIf="payments.length">

    <div class="margin-top-20">
        <app-pagination [params]="params" (update)="search()"></app-pagination>


        <table class="mat-elevation-z2 example-full-width data-listing">
            <thead>
            <tr>
                <th>Paid?</th>
                <th>Checked?</th>
                <th>Payment Link</th>
                <th></th>
                <th>Reference</th>
                <th>Brand</th>
                <th>To Pay</th>
                <td>Paid</td>
                <th>Status</th>
                <th>Created</th>
                <th>Customer</th>
                <th>Email</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let p of payments">
                <td>
                    <i class="fa fa-check text-success" *ngIf="p.paid > 0 && p.success"></i>
                </td>
                <td class="hover" (click)="markPaymentAsChecked(p)">
                    <i class="fa fa-check text-success" *ngIf="p.paymentChecked"></i>
                    <i class="fa fa-check text-danger" *ngIf="!p.paymentChecked"></i>
                </td>

                <!-- <td><a [href]="'https://eu.adyen.link/' + p.payUrlId" target="_blank">{{p.payUrlId}}</a></td> -->
                <td>
                    <a [href]="'https://ca-live.adyen.com/ca/ca/transactions/payment-link-details.shtml?d=' + p.payUrlId" target="_blank">{{p.payUrlId}}</a>
                </td>
                <td>
                    <a *ngIf="p.bookingId && p.bookingId !== 'new'" [routerLink]="['/bookings', p.bookingId]">View Booking</a>
                </td>
                <td>{{p.reference}}</td>
                <td>{{p.hotelName}}</td>
                <td>{{p.toPay}}</td>
                <td>{{p.paid}}</td>
                <td *ngIf="p.status === ''"></td>
                <td *ngIf="p.status === 'Active'">
                    <i class="fa fa-circle" style="color: blue;"></i> Active
                </td>
                <td *ngIf="p.status === 'Completed' && p.success">
                    <i class="fa fa-circle text-success"></i> Completed
                </td>
                <td *ngIf="p.status === 'Completed' && !p.success">
                    <div class="badge badge-danger">Payment failed</div>
                    <!-- <i class="fa fa-times-circle text-danger"></i> Failed -->
                </td>
                <td *ngIf="p.status === 'Expired'">
                    <i class="fa fa-circle text-danger"></i> Expired
                </td>
                <td>{{p.createdAt | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td>{{p.firstname}} {{p.surname}}</td>
                <td>{{p.username}}</td>
            </tr>
            </tbody>
        </table>

        <app-pagination [params]="params" (update)="search()"></app-pagination>
    </div>


</ng-container>
